// get data for entering a room/meeting
// https://mccglc.atlassian.net/l/c/YRMgJ9VT for DOCS

const state = {
  showLobby: false,
};

const getters = {
  showRoomLobby: (state) => state.showLobby,
  inRoomLobby: (state, getters, rootState, rootGetters) => getters.showRoomLobby && rootGetters['routing/routeName'] === 'room',
};

const mutations = {
  setShowRoomLobby: (state, value) => { state.showLobby = value},
};

const actions = {
  async updateIfEnterRoomClicked({commit},value) {
    commit('setIfEnterRoomClicked', value)
  },
  async handleSwitchRoom({getters,dispatch}, id) {
    //check if re-joining current room or if joining new room whilst in a different room
    let inMeeting = !getters.getIfCurrentUsersRoomIsHub && (!getters['loading/isFirstLoad'] && id !== getters.getCurrentUsersRoomId)
    if(inMeeting) {
      // show switch room popup if already in a meeting
      dispatch('popups/nav/confirmSwitchRoom', () => dispatch('routing/goToRoom', id), {root: true})
    } else {
      dispatch('routing/goToRoom', id)
    }
  },

  async showRoomLobbyHandler({commit}) {
    commit('setShowRoomLobby', true)
  },
  async hideRoomLobby({commit}) {
    commit('setShowRoomLobby', false)
  },

  async handleJoinRoom({getters,commit,dispatch}, id) { //called on re-entering call from lobby even if same as current users room
    id = id || getters.getCurrentSpacePageData?.id
    if(!id) return console.error("handleJoinRoom: No id")

    if(getters.isDesktop) await dispatch('sidebar/open', 'chats', {root: true})
    else dispatch('sidebar/close', null, {root: true})

    let res = await dispatch('api/nav/joinRoom',id)
    commit('setLoadingSpace', false)
    let data = res.success
    if(data) {
      dispatch('hideRoomLobby')
      dispatch('guest/space/hideLobby')
      let currentRoomId = getters.getCurrentUsersRoomId
      await dispatch('updateLocation',[data])
      dispatch('handleOpenRoomLink', data)
      //only send analytics if first join (not re-entering from lobby)
      if(currentRoomId !== data.id) dispatch('analytics/joinRoom')
      await dispatch('acceptInviteOnJoiningRoom', id, {root: true})

      dispatch('search/checkForGuestsInRoomLobby', null, {root: true})
    } else {
      dispatch('popups/nav/errorJoiningRoom')
      if(!getters.inRoomLobby) dispatch('routing/goToCurrentArea')
      else dispatch('guest/room/resetRoomLobby')
    }
  },
  async handleOpenRoomLink(context,data) {
    setTimeout(() => { //slight delay for less confusion on refresh, create, etc
      if(data.conferenceType === 'link' || data.conferenceType === 'unknown') window.open(data.joinLink, '_blank').focus()
    }, 500)
  },
};

export default {
  state,
  getters,
  mutations,
  actions
};
